import * as z from "zod";

export const getGrowaveIntegration = {
  name: "getGrowaveIntegration" as const,
  input: z.null(),
  output: z.object({
    exists: z.boolean(),
    clientId: z.string().optional(),
    clientSecret: z.string().optional(),
  }),
};
